import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
export function ContactBand() {
  return <section aria-labelledby="contact-title" className="border-t border-line" data-id="element-65" data-mp="30qoh0cpxk5t6">
      <div className="mx-auto grid max-w-site gap-10 px-6 py-20 lg:grid-cols-12 lg:items-end lg:px-10 lg:py-24" data-id="element-66" data-mp="2mqdn10tbqb3s">
        <div className="lg:col-span-8" data-id="element-67" data-mp="2qrp8qv92uc6p">
          <h2 id="contact-title" className="font-serif text-4xl leading-tight tracking-tight text-ink lg:text-5xl" data-id="element-68" data-mp="3egi5gtxiwo2d">
            Un projet, une consultation en cours&nbsp;?
          </h2>
          <p className="mt-5 max-w-2xl text-[17px] leading-relaxed text-muted" data-id="element-69" data-mp="3jhpfz0r1w1cq">
            Présentez-nous votre territoire et vos enjeux. Un associé du cabinet vous recontacte sous 48 heures
            pour échanger sur votre besoin.
          </p>
        </div>
        <div className="flex flex-col gap-4 lg:col-span-4 lg:items-end" data-id="element-70" data-mp="196n7otch7za">
          <Link to="/contact" className="inline-flex items-center justify-center gap-3 whitespace-nowrap bg-ink px-7 py-4 text-[15px] text-paper transition-colors duration-150 hover:bg-ink-soft" data-id="element-71" data-mp="61845o1gjmvn">
            Prendre contact
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-72" data-mp="wlmerw8yhej" />
          </Link>
          <a href="tel:+33142000000" className="text-[15px] text-ink-soft hover:text-ink" data-id="element-73" data-mp="fovtpobo7nid">
            ou appelez le 01 42 00 00 00
          </a>
        </div>
      </div>
    </section>;
}